import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";

class BookFiltersStore extends EventEmitter {
	constructor() {
		super();
		this.bookFilterChoices = {
			platform: "",
			auditlevel: ""
		};

		this.currencySymbol = null;

		this.formulas = {
			data: []
		};

		this.contextValues = {};

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.addAllAarcValues:
					this.formulas.data = action.formulas;
					break;
				case AppActionConstants.putFilters:
					this.bookFilterChoices[action.name] = action.value;
					break;
				case AppActionConstants.fetchCurrencySymbols:
					this.currencySymbol = action.value;
					break;
				case AppActionConstants.fetchSyncStatusesSuccess:
					this.SyncStatuses = action.value;
					this.emit("fetchSyncStatusesSuccess");
					break;
				case AppActionConstants.fetchSyncStatusesFailure:
					this.emit("fetchSyncStatusesFailure");
					break;
				case AppActionConstants.storeContextValues:
					this.contextValues = action.value;
					break;
				default:
					break;
			}
		});
	}

	getChoicesState = () => this.bookFilterChoices;
	getCurrencySymbol = () => this.currencySymbol;
	getSyncStatuses = () => this.SyncStatuses;
	getContextValues = () => this.contextValues;

	getFormulas = () => this.formulas.data;
}

export default new BookFiltersStore();
